<script setup>
import {ref} from "vue";
import {useLanguageStore} from "@/pinia";

const languageStore = useLanguageStore();
const props = defineProps(['isFolderModal'])
const emits = defineEmits(['set_isFolderModal', 'saveFolder'])
const folderName = ref();
const save = ()=>{
  emits('saveFolder', folderName.value)
  folderName.value= ""
}
const close = ()=>{
  folderName.value= ""
  emits("set_isFolderModal", false)
}
</script>

<template>
  <v-dialog
      :model-value="isFolderModal"
      @update:modelValue="close"
      width="auto"
  >
    <v-card
        :title="languageStore.get('folderCreate')"
        width="600"
    >
      <v-card-text>
        <v-text-field
            v-model="folderName"
            :label="languageStore.get('folderName') + ' *'"
            variant="outlined"
            density="compact"
            hide-details="auto"
            autofocus
            @keyup.enter="save"
        ></v-text-field>
      </v-card-text>
      <v-card-actions class="modal-actions">
        <v-spacer></v-spacer>
        <v-btn color="primary" variant="flat" @click="save">{{ languageStore.get('save') }}</v-btn>
        <v-btn variant="outlined" @click="close">{{ languageStore.get('close') }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<style scoped>
/* 모달 헤더 스타일 */
:deep(.v-card-item) {
  background-color: #1A3A5C !important;
  padding: 0 !important;
}

:deep(.v-card-title) {
  background-color: #1A3A5C !important;
  color: #FFFFFF !important;
  padding: 16px 24px !important;
  font-weight: 600 !important;
  font-size: 18px !important;
}

/* 모달 바디 - Vuetify 기본 padding 제거 */
:deep(.v-card-text) {
  padding: 24px !important;
}

/* 모달 액션 - Vuetify 기본 padding 제거 */
:deep(.v-card-actions.modal-actions) {
  padding: 16px 24px !important;
  border-top: 1px solid #DEE2E6;
  gap: 8px;
}

/* v-card-text 내 입력 필드 간격 */
.v-card-text :deep(.v-input) {
  margin-bottom: 16px;
}

.v-card-text :deep(.v-input:last-child) {
  margin-bottom: 0;
}
</style>